var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{attrs:{"id":"main-content"}},[_c('a',{attrs:{"href":_vm.link_url,"target":"_blank"}},[_c('img',{attrs:{"id":"poster-img","src":_vm.img_url}})])]),_c('div',{attrs:{"id":"rating"}},[_c('h4',[_vm._v("RATING: "+_vm._s(_vm.rating))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }